<template>
  <div>
    <el-form v-model="fromData" size="small" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="'评审状态'">
            <el-radio-group size="small" v-model="fromData.reviewStatus">
              <el-radio-button label="Y"> {{ '通过' }} </el-radio-button>
              <el-radio-button label="N"> {{ '未通过' }} </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'评审意见'">
            <el-input
              type="textarea"
              :placeholder="'请输入评审意见'"
              v-model="fromData.reviewDesc"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    changeOrderCode: String,
    code: String,
    type: String,
  },
  data() {
    return {
      fromData: { reviewStatus: 'Y', isFinal: 'N' },
      reviewStatusParams: { dictType: 'reviewStatus' },
    }
  },
  mounted() {
    this.getData(this.code)
  },
  methods: {
    getData(code) {
      if (!this.code) return
      this.loadingOpen()
      this.$api
        .changeOrderReviewDetailApi({ changeOrderReviewCode: code })
        .then((res) => {
          this.loadingClose()
          this.fromData = res.body
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    saveOrderReview(code) {
      this.$confirm(
        '是否保存该评审记录',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        if (this.type === 'addFinal') {
          this.fromData.isFinal = 'Y'
        }
        this.$api
          .changeOrderReviewSaveApi({
            changeOrderCode: code,
            ...this.fromData,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success',
              })
              if (this.type === 'addFinal') {
                this.$emit('closeDialog')
                this.$emit('saveOkQuestion')
                return
              }
              this.$emit('closeDialog')
              this.$emit('reload')
              this.$emit('saveOkQuestion')

            }
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.aas {
  margin-left: 4%;
}
</style>
